import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

const dateTimeFormat = 'MM/DD/YYYY h:mm:ss A';
const dateWithOrdinalFormat = 'Do MMMM YYYY';

export const isThisWeekEvent = (event) => {
  const startAt = dayjs(event.startAt, dateTimeFormat);
  const endAt = dayjs(event.endAt, dateTimeFormat);
  const normalizedStart = startAt.isValid() ? startAt : dayjs(event.startAt);
  const normalizedEnd = endAt.isValid() ? endAt : dayjs(event.endAt);

  return dayjs().endOf('isoWeek') > normalizedStart && dayjs() <= normalizedEnd;
};

export const isNextMonthEvent = (event, monthsToAdd) => {
  return (
    dayjs().add(monthsToAdd, 'month').endOf('month') > dayjs(event.startAt) &&
    dayjs().add(monthsToAdd, 'month').startOf('month') < dayjs(event.endAt) &&
    (dayjs(event.endAt).subtract(1, 'day').get('month') !==
      dayjs()
        .add(monthsToAdd - 1, 'month')
        .get('month') ||
      dayjs(event.startAt).format('MM') === dayjs(event.endAt).format('MM'))
  );
};

export const formatDateRangeWithOrdinal = (startAt, endAt) => {
  // same day
  if (startAt === endAt) {
    return dayjs(startAt).format(dateWithOrdinalFormat);
  }
  // same month
  if (dayjs(startAt).format('MM-YYYY') === dayjs(endAt).format('MM-YYYY')) {
    return `${dayjs(startAt).format('Do')} - ${dayjs(endAt).format(dateWithOrdinalFormat)}`;
  }
  // same year
  if (dayjs(startAt).format('YYYY') === dayjs(endAt).format('YYYY')) {
    return `${dayjs(startAt).format('Do MMMM')} - ${dayjs(endAt).format(dateWithOrdinalFormat)}`;
  }
  // different year
  return `${dayjs(startAt).format(dateWithOrdinalFormat)} - ${dayjs(endAt).format(
    dateWithOrdinalFormat
  )}`;
};

export const formatTimeRange = (startAt, endAt) => {
  const inputFormat = 'HH:mm:ss';
  const outputFormat = 'h:mma';

  return `${dayjs(startAt, inputFormat).format(outputFormat)} - ${dayjs(endAt, inputFormat).format(
    outputFormat
  )}`;
};
